var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rr-loading"},[_c('img',{attrs:{"src":require("../assets/loading.png"),"alt":"loklok loading"}})])
}]

export { render, staticRenderFns }